import React from 'react';
import {
  formatDateStrWithTime,
  formatTimeStr,
  getStartOfDayInTimezone,
} from 'utils';
import DatePicker from './DatePicker';
import styles from './appointment_book.module.scss';

const Step2Date = ({
  state,
  listing,
  isListingContact,
  currentStep,
  mobileWorkflowSteps,
  isMobile,
  dateNotAvailable,
  offerDate,
  offerAnytime,
  isAdmin,
  isListingAgent,
  isTimeChange,
  enableOpenHouses,
  openHouseDays,
  showCaptcha,
  unavailableDays,
  unavailableAfter,
  originalDate,
  originalAppointment,
  serverDate,
  // functions
  updateState,
  updateDate,
  // angular
  $rootScope,
  UtilService,
}) => {
  const comingSoonDate =
    listing.status === 'Coming Soon'
      ? getStartOfDayInTimezone(listing.coming_soon_date, listing.timezone)
      : null;

  return (
    <div
      className={`form-group col-md-5 ${
        currentStep === mobileWorkflowSteps.selectDateStep
          ? styles.stepActive
          : styles.stepInactive
      }`}
    >
      <hr className={`${styles.titleDivider} ${styles.titleDividerTop}`} />
      <h3 className={styles.titleBlock}>
        <span className={styles.stepNumber}>Step 2 - </span>
        <span className={styles.stepTitle}>Select Date</span>
        {isMobile && isListingContact && isTimeChange && (
          <div className={styles.orignalTimeSubTitle}>
            <strong>Original Request:</strong>{' '}
            {formatDateStrWithTime(originalAppointment.time, listing.timezone)}
            {' - '}
            {formatTimeStr(originalAppointment.timeEnd, listing.timezone)}
          </div>
        )}
      </h3>
      <hr className={`${styles.titleDivider} ${styles.titleDividerBottom}`} />
      <div
        id="DatepickerContainer"
        className={`${styles.contentScrollableOnMobile} ${styles.flexGrow}`}
      >
        <DatePicker
          {...state}
          state={state}
          updateState={updateState}
          offerDate={offerDate && offerDate.format('YYYY-MM-DD')}
          offerAnytime={offerAnytime}
          openHouseDays={enableOpenHouses ? openHouseDays : []}
          pickDate={!showCaptcha}
          pickPast={(isAdmin || isListingAgent) && !isTimeChange}
          unavailableDays={unavailableDays}
          unavailableAfter={unavailableAfter}
          updateFn={updateDate}
          month={state.month}
          originalDate={originalDate}
          $rootScope={$rootScope}
          UtilService={UtilService}
          comingSoonDate={comingSoonDate}
          serverDate={serverDate}
        />

        {isMobile && dateNotAvailable && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <br />
            <strong className="text-danger" style={{ fontSize: '16px' }}>
              NO AVAILABLE TIMES ON THIS DAY
            </strong>
          </div>
        )}
      </div>
    </div>
  );
};
export default Step2Date;
